import script from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPage.vue?vue&type=style&index=0&id=a5daf348&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5daf348"]])

export default __exports__